import { ThemeDefinition } from 'vuetify';

export const history: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#596A79',
    'on-subject-original': '#FFFFFF',
    subject: '#526270',
    'on-subject': '#FFFFFF',
    primary: '#4C5A67',
    'on-primary': '#FFFFFF',
    'primary-container': '#D3D9DF',
    'on-primary-container': '#1A1F23',
    secondary: '#52575B',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D7D9DB',
    'on-secondary-container': '#1D1F20',
    surface: '#F9FAFB',
    'on-surface': '#1D1F20',
    'on-surface-medium': '#494D50',
    'on-surface-low': '#94999E',
    outline: '#798086',
    'outline-variant': '#C4CCD4',
    'inverse-surface': '#2B333B',
    'inverse-on-surface': '#F0F2F4',
    'inverse-primary': '#C4CCD4',
    'surface-dim': '#D0D7DC',
    'surface-bright': '#FCFCFD',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F3F5F6',
    'surface-container': '#EDF0F2',
    'surface-container-high': '#E2E6E9',
    'surface-container-highest': '#DCE1E5',
  },
};

export const historyDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#596A79',
    'on-subject-original': '#F9FAFB',
    subject: '#AAB6C0',
    'on-subject': '#1A1F23',
    primary: '#C7CFD6',
    'on-primary': '#1A1F23',
    'primary-container': '#414D58',
    'on-primary-container': '#F0F2F4',
    secondary: '#CCCFD1',
    'on-secondary': '#1D1F20',
    'secondary-container': '#494D50',
    'on-secondary-container': '#F2F2F3',
    surface: '#111517',
    'on-surface': '#F2F2F3',
    'on-surface-medium': '#C9CCCF',
    'on-surface-low': '#798086',
    outline: '#94999E',
    'outline-variant': '#61666B',
    'inverse-surface': '#E2E6E9',
    'inverse-on-surface': '#1A1F23',
    'inverse-primary': '#2B333B',
    'surface-dim': '#0F1215',
    'surface-bright': '#323B43',
    'surface-container-lowest': '#0D0F12',
    'surface-container-low': '#161A1D',
    'surface-container': '#1C2126',
    'surface-container-high': '#252C32',
    'surface-container-highest': '#303941',
  },
};
